import dayjs from 'dayjs';
import { observer } from 'mobx-react';
import { FC, useState } from 'react';
import { JobsDataType } from '../../../../ types';
import { StagesStore } from '../../../../../DataSource/Stores/Cabinet/StagesStore';
import { WorkspacesStore } from '../../../../../DataSource/Stores/Cabinet/WorkspacesStore';
// import uWS from '../../../../uWS';
import { Avatar, Flex } from 'antd';
import { config } from '../../../../../config';
import Button from '../../../../ui/Button';
import Icon from '../../../../ui/Icon';
import ProgressBar from '../../../../ui/ProgressBar';
import TagList from '../../../DeliveryCenterNew/Kanban/JobCard/TagList';
import JobDrawer from './JobDrawer';
import * as styles from './index.module.scss';

const JobColumnItem: FC<JobsDataType & { dragProps: any }> = ({
  _id,
  name,
  stageId,
  jobId,
  jobData,
  workspaceId,
  externalId,
  prodImage,
  prodImages,
  targetDate,
  assignedTo,
  comments,
  startDate,
  expectedDate,
  dragProps,
  labels,
  tags,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
    StagesStore.getJobsId(workspaceId, _id).catch((e) => {
      console.error(e);
    });
  };

  // const showModalForce = (forceId: string) => {
  //   setIsModalOpen(true);
  //   StagesStore.getJobsId(workspaceId, forceId).catch((e) => {
  //     console.error(e);
  //   });
  // };

  // useEffect(() => {
  //   if (!StagesStore?.dataJobs?.job?._id) return;
  //   const eventStatus = uWS.subscribe(
  //     `jobs/${StagesStore.dataJobs.job._id}/changeTaskStatus`,
  //     (data: any) => {
  //       if (data.error) {
  //         console.error('Error subscribing to jobs changeTaskStatus:', data.error);
  //         return;
  //       }
  //
  //       // console.log('changeTaskStatus:', data);
  //       // console.log('!StagesStore?.dataJobs?.job?._id', !StagesStore?.dataJobs?.job?._id);
  //       // console.log(
  //       //   'StagesStore?.dataJobs?.job?._id !== data.jobId',
  //       //   StagesStore?.dataJobs?.job?._id !== data.jobId
  //       // );
  //       // console.log('!isModalOpen', !isModalOpen);
  //       if (!StagesStore?.dataJobs?.job?._id) return;
  //
  //       if (StagesStore?.dataJobs?.job?._id !== data.jobId) {
  //         return;
  //       }
  //
  //       // if (!isModalOpen) {
  //       //   return;
  //       // }
  //
  //       console.log('Ljitk');
  //       StagesStore.getJobsId(workspaceId, data.jobId).catch((e) => {
  //         console.error(e);
  //       });
  //       // showModalForce(StagesStore.dataJobs.job._id);
  //     }
  //   );
  //
  //   return () => {
  //     if (eventStatus && StagesStore?.dataJobs?.job?._id)
  //       uWS.unSubscribe(`jobs/${StagesStore.dataJobs.job._id}/changeTaskStatus`);
  //   };
  // }, [StagesStore?.dataJobs?.job?._id]);

  const member = assignedTo ? WorkspacesStore.members[assignedTo]?.userId : null;

  return (
    <>
      <div className={styles.jobColumnItem}>
        <button className={styles.dragHandle} {...dragProps}>
          <Icon slug="drag_handle" />
        </button>
        <div className={styles.right}>
          <p className={styles.title}>{name}</p>

          <div className={styles.infoBlock}>
            <Button autoWidth onClick={showModal}>
              #{jobId}
              <Icon slug="arrow_vertical" />
            </Button>

            <div className={styles.dateBlock}>
              {dayjs(targetDate).format('HH : mm')}
              <span className={styles.separator}>•</span>
              {dayjs(targetDate).format('DD/MM/YY')}
            </div>

            {member && (
              <div className={styles.member}>
                {member.photo && (
                  <Avatar
                    src={`${config.EXTERNAL_ADDRESS}/image-uploader/${member.photo}`}
                    shape="circle"
                    size={32}
                  />
                )}
                {!member.photo && <div className={styles.picture}>{member.firstname[0]}</div>}
                <p className={styles.name}>{member.firstname}</p>
              </div>
            )}
          </div>

          {stageId === '66e194a01725b77d117c4d5a' && expectedDate && (
            <ProgressBar startDate={startDate} expectedDate={expectedDate} />
          )}

          {!!labels?.length && (
            <Flex align="center" gap={8}>
              {labels.map((label) => (
                <div key={label.id} className={styles.label}>
                  {label.caption}
                </div>
              ))}
            </Flex>
          )}

          {!!tags?.length && <TagList tags={tags} color="neutral" />}
        </div>
      </div>

      <JobDrawer
        workspaceId={workspaceId}
        name={name}
        jobId={jobId}
        jobData={jobData}
        prodImage={prodImage}
        prodImages={prodImages}
        targetDate={targetDate}
        expectedDate={expectedDate}
        stageId={stageId}
        assignedTo={assignedTo}
        comments={comments}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        _id={_id}
        bitrixId={externalId?.bitrixId}
        labels={labels}
      />
    </>
  );
};

export default observer(JobColumnItem);
